/**
 * RevivalNudge — first child of <ThisWeekGroup> when the user has
 * lapsed (no reflection in N+ weeks) and there's no active weekly
 * plan. Pulls them back into the Coach with a deliberately small ask
 * ("restart small") rather than another seven-day commitment.
 */
import React from 'react';
import { ArrowRight, Heart, MessageCircleHeart } from 'lucide-react';

export default function RevivalNudge({ streak, onRevive }) {
  const longest = streak.longest_streak || 0;
  const weeks = streak.weeks_since_last;
  const headline = longest >= 2
    ? `You had a ${longest}-week streak. Want to start a fresh one this week?`
    : 'Want to pick this back up — small and doable?';
  const bodyDetail = weeks
    ? `It's been about ${weeks} ${weeks === 1 ? 'week' : 'weeks'} since your last reflection. No guilt — life happens.`
    : 'No guilt — life happens.';
  return (
    <section
      className="pie-card pie-revival-nudge"
      data-testid="pie-revival-nudge"
    >
      <div className="pie-revival-icon" aria-hidden>
        <Heart size={18} />
      </div>
      <div className="pie-revival-body">
        <h3 className="pie-revival-headline">{headline}</h3>
        <p className="pie-revival-sub">{bodyDetail} The Coach will help you pick one tiny thing — not another seven-day commitment.</p>
      </div>
      <button
        type="button"
        className="pie-btn pie-btn-primary pie-revival-cta"
        onClick={onRevive}
        data-testid="pie-revival-cta"
      >
        <MessageCircleHeart size={14} /> Restart small <ArrowRight size={14} />
      </button>
    </section>
  );
}
